import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { LfaContextAPIShape } from '../../../Context/LfaContext';
import InputTextArea from '../../FormFields/TextArea';
import Button from '../../Common/Button';
import DFFNotesService from '../../../Services/DFFNotesService';
import FormContextProvider, { FormContext } from '../../../Context/FormContext';
import Utils from '../../../Services/Utils';
import Icon from "../../Common/Icon";
import {ReactComponent as CloseIcon} from "../../../../img/dialog-close.svg";

class ModalFieldNote extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      oldText: this.props.data.notes || '',
      text: this.props.data.notes || '',
      errors: {},
    };
  }

  onPressClose = (event) => this.props.onClose(event);

  onPressSave = async (event) => {
    await DFFNotesService.setNotes(this.props.api, this.props.configuration, this.state.text);
    this.props.onClose(event);
  };

  onChangeText = (text) => {
    this.setState({
      text,
    });
  };

  onChangeError = (key, error) => {
    const { errors } = this.state;
    errors[key] = error;
    this.setState({
      errors,
    });
  };

  render() {
    const {text, errors, oldText} = this.state;
    return (
      <FormContextProvider>
        <FormContext.Consumer>
          { context => (
            <Modal
              isOpen
              onRequestClose={ this.onPressClose }
              contentLabel='Add note'
              className='Modal_Content'
              overlayClassName='Modal_Overlay'
            >
              <div className='Modal_Content_Container Center'>
                <h2>ADD NOTES</h2>
                <InputTextArea
                  placeholder='Notes'
                  onChange={ this.onChangeText }
                  required={ Boolean(Utils.isNull(oldText)) }
                  value={ text }
                  error={ errors['text'] }
                  onError={ (error) => this.onChangeError('text', error) }
                />
                <div className='Modal_Content_Actions Center'>
                  <Button className='Button_Small Inline'
                    onClick={ (event) => context.submit(() => this.onPressSave(event), errors)  }
                  >
                    Save
                  </Button>
                  <Button className='Button_Small Button_Cancel Inline'
                    onClick={ (event) => context.cancel(() => this.onPressClose(event)) }
                  >
                    Cancel
                  </Button>
                </div>
                <div className='Modal_Content_Close' onClick={ (event) => context.cancel(() => this.onPressClose(event)) }>
                  <Icon className='Icon-Close' width='12' height='12' color='secondaryColor'>
                    <CloseIcon alt='icon-close'/>
                  </Icon>
                </div>
              </div>
            </Modal>
          ) }
        </FormContext.Consumer>
      </FormContextProvider>
    );
  }
}

ModalFieldNote.propTypes = {
  configuration: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  api: LfaContextAPIShape,
  onClose: PropTypes.func.isRequired,
};

export default ModalFieldNote;
